<template>
	<div class="products">
		<h2 class="product-title" v-if="item.titleFlag==1">{{item.detailTitle}}</h2>
		<ul class="product-nav">
			<li @click="changeSinglePage(item.id, item2.id,index)" :class="[singlePageIndex==index?'active':'']"
				v-for="(item2,index) in item.list">{{item2.categoryName}}</li>
		</ul>
		<div class="product-cnt">
			<div class="main-cnt" v-for="item3 in singlePageList">
				<div class="layout1" v-if="item3.layout==1">
					<p v-html="item3.content"></p>
				</div>
				<div class="layout-txt2" v-if="item3.layout==2">
					<div class="layout-txt-list" v-html="item3.content" :style="`width:${item3.oneRatio}%`" v-if="item3.oneRatio>0">
					</div>
					<div class="layout-txt-list" v-html="item3.twoContent" :style="`width:${item3.twoRatio}%`" v-if="item3.twoRatio>0">
					</div>
				</div>
				<div class="layout-txt3" v-if="item3.layout==3">
					<div class="layout-txt-list" v-html="item3.content" :style="`width:${item3.oneRatio}%`" v-if="item3.oneRatio>0">
					</div>
					<div class="layout-txt-list" v-html="item3.twoContent" :style="`width:${item3.twoRatio}%`" v-if="item3.twoRatio>0">
					</div>
					<div class="layout-txt-list" v-html="item3.threeContent" :style="`width:${item3.threeRatio}%`" v-if="item3.threeRatio>0">
					</div>
				</div>
			</div>
			<div class="line"></div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	export default {
		name: 'SystemTab',
		props: {
			item: {
				type: Object,
				value: {}
			}
		},
		data(){
			return{
				singlePageIndex: 0,
				singlePageList: []
			}
		},
		created(){
			if(this.item.list.length>0){
				this.getSinglePageList(this.item.id,this.item.list[0].id)
			}
		},
		methods: {
			//切换操作系统分类
			changeSinglePage(detailId, systemId, index) {
				this.singlePageIndex = index
				this.getSinglePageList(detailId,systemId)
			},
			//获取系统分类数据
			async getSinglePageList(detailId, systemId) {
				let param = {
					detailId: detailId,
					categoryIdOne: systemId
				}
				ajaxParam(param)
				const res = await post('v1/product/singlePageList', qs.stringify(param))
				if (res.data.code == 200) {
					this.singlePageList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			}
			
		}
	}
</script>

<style scoped lang="less">
	.products {
		padding-top: 50px;
		//padding-top: 110px;
		.product-title {
			font-size: 34px;
			text-align: center;
		}
	
		.product-nav {
			display: flex;
			width: 1180px;
			background: #fff;
			border-radius: 30px;
			margin: 40px auto 0;
			line-height: 1.95;
			font-size: 16px;
			justify-content: space-around;
	
			li {
				width: 25%;
				padding: 15px 0;
				text-align: center;
				cursor: pointer;
			}
	
			li.active {
				background: #DE0515;
				border-radius: 30px;
				color: #fff;
			}
	
			li.active:hover {
				color: #fff;
			}
	
			li:hover {
				color: #DE0515;
			}
		}
	
		.product-cnt {
			width: 1180px;
			margin: 0 auto;
			padding-top: 40px;
	
			.main-cnt {
				display: flex;
				justify-content: space-between;
				background: #fff;
				border-radius: 10px;
				padding: 40px;
			}
	
			.type-cnt {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
	
				li {
					width: 31%;
					margin-bottom: 40px;
	
					.type-list {
						padding: 42px 50px 45px 50px;
						background: #fff;
	
						.type-h3 {
							padding-bottom: 20px;
							font-size: 28px;
							line-height: 1.57;
						}
	
					}
				}
			}
		}
	}
	.link {
		display: flex;
		align-items: center;
		color: #DE0515;
	
		.text {
			line-height: 1.625;
		}
	
		.el-icon-right {
			font-size: 22px;
		}
	}
	.layout-txt2, .layout-txt3{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		.layout-txt-list{
			padding-right: 1%;
			box-sizing: border-box;
		}
		.layout-txt-list:last-of-type{
			padding-right: 0;
		}
	}
</style>
